import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@myrtls/api-interfaces';
import { Actions, createEffect, ofType, rootEffectsInit } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CONFIG_API_URL } from '../../shared/utils/constants';
import {
    getConfigAction,
    getConfigFailureAction,
    getConfigSuccessAction,
} from './config.actions';

@Injectable()
export class ConfigEffects {
    // the configuration is public, it is loaded before the user is authenticated
    private readonly httpWithoutAuth: HttpClient;

    configInit$ = createEffect(() =>
        this.actions$.pipe(
            ofType(rootEffectsInit),
            map(() => getConfigAction()),
        ),
    );

    getConfig$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getConfigAction),
            switchMap(() =>
                this.httpWithoutAuth.get<AppConfig>(CONFIG_API_URL).pipe(
                    map(config => getConfigSuccessAction({ config })),
                    catchError(error => of(getConfigFailureAction({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private readonly actions$: Actions,
        private readonly httpBackend: HttpBackend,
    ) {
        this.httpWithoutAuth = new HttpClient(this.httpBackend);
    }
}
